import { AppConfig } from '@/constants/AppConfig';
import { PointsEarnedLineItem } from '@/pages/CustomerDashboard/Benefits/PointsEarnedLineItem';
import { ElevatedCard } from '@/pages/CustomerDashboard/ElevatedCard';
import { getRewardsValueText } from '@/utilities/RewardsProgramUtility';
import { ApiManufacturer, ApiPromotion } from '@api/interfaces';
import { Divider } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from "@/components/DesignSystem";

interface ManufacturerPromotionsPointsEarnedCardProps {
  manufacturer: ApiManufacturer,
  promotions: ApiPromotion[],
  testID: string,
}

export const ManufacturerPromotionsPointsEarnedCard = ({
  manufacturer,
  promotions,
  testID,
}: ManufacturerPromotionsPointsEarnedCardProps) => {
  const { t, i18n } = useTranslation();
  const imageUrl = manufacturer.logomark && `${AppConfig.staticImageHost}/${manufacturer.logomark}`;
  const sortedPromotions = promotions.sort((a, b) => a.name.localeCompare(b.name));
  return (
    <ElevatedCard
      fallbackImage="manufacturer"
      imageUrl={imageUrl ?? undefined}
      testID={testID}
      title={manufacturer.name ?? ''}
    >
      <Text align='right' category="body-small">
        {t($ => $.customerDashboard.tierBenefits.pointPerUnit)}
      </Text>
      <Divider />
      {sortedPromotions.map((promotion) => (
        <PointsEarnedLineItem
          key={promotion.id}
          label={promotion.name}
          value={getRewardsValueText(promotion.rewardType, promotion.value, promotion.uom, t, i18n)}
        />
      ))}
    </ElevatedCard>
  );
};
